export default import.meta.ROLLDOWN_FILE_URL_Z1uaJTSe3nQTdrWHW_Y$DQ